import { Block, BlockSchema } from './Block.types';

import { PagePasswordBlockConfigSchema, BlockType } from './blockConfig/Types';

import { z } from 'zod';

export const PAGE_PASSWORD = 'pagePassword';

export enum PagePasswordLayout {
  Standard = 'standard',
}

export const PagePasswordBlockSchema = BlockSchema.extend({
  blockConfig: PagePasswordBlockConfigSchema,
});

export type PagePasswordBlock = z.infer<typeof PagePasswordBlockSchema>;

export function isPagePasswordBlock(block: Block): block is PagePasswordBlock {
  return block.blockConfig.type === BlockType.PagePassword;
}
